import type { DocumentStatus, DocumentType } from '@types';

export function TypeBadge({ type }: { type: DocumentType }) {
  const isInvoice = type === 'invoice';
  return (
    <span
      data-testid="doc-type-badge"
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${
        isInvoice
          ? 'bg-indigo-100 text-indigo-800'
          : 'bg-teal-100 text-teal-800'
      }`}
    >
      {isInvoice ? 'Invoice' : 'Quote'}
    </span>
  );
}

const STATUS_STYLES: Record<DocumentStatus, string> = {
  DRAFT: 'bg-gray-100 text-gray-700',
  ISSUED: 'bg-blue-100 text-blue-800',
  ACCEPTED: 'bg-green-100 text-green-800',
  DECLINED: 'bg-red-100 text-red-800',
  CONVERTED: 'bg-purple-100 text-purple-800',
  VOID: 'bg-gray-200 text-gray-600 line-through',
  PAID: 'bg-emerald-100 text-emerald-800',
};

export function StatusBadge({ status }: { status: DocumentStatus }) {
  return (
    <span
      data-testid="doc-status-badge"
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${STATUS_STYLES[status]}`}
    >
      {status}
    </span>
  );
}

export function ExpiredBadge() {
  return (
    <span
      data-testid="doc-expired-badge"
      className="inline-flex items-center rounded-full bg-amber-100 px-2.5 py-0.5 text-xs font-medium text-amber-800"
    >
      EXPIRED
    </span>
  );
}

export function ImportedBadge() {
  return (
    <span
      data-testid="doc-imported-badge"
      className="inline-flex items-center rounded-full bg-slate-100 px-2.5 py-0.5 text-xs font-medium text-slate-700"
    >
      Imported
    </span>
  );
}
